// extracted by mini-css-extract-plugin
module.exports = {"orderFirstOnMobile":"SubscriptionsList_orderFirstOnMobile__Nk56I","orderLastOnMobile":"SubscriptionsList_orderLastOnMobile__yoKas"};